
class PayModal {
    constructor(id) {
        this.element = document.getElementById(id);
        this.mtElement = this.element.querySelector('#smsText');

        this.cardElement = document.getElementById('payByCard');
        this.qsakElement = document.getElementById('payByQsak');
        this.idramElement = document.getElementById('payByIdramButton');
        this.idramForm = document.getElementById('idramForm');

        this.smsElement = document.getElementById('payBySMS');
        this.smsCancelElement = document.getElementById('cancelSMS');

        this.emailInput = this.element.querySelector('input[name="email"]');
        this.phoneInput = this.element.querySelector('input[name="phone"]');

        this.state = {
            isOpen: false
        };

        this.initEvents();
    }

    open(id) {
        this.announcementID = id;
        this.state.isOpen = true;

        window.$(this.element).modal({
            escapeClose: false,
            clickClose: false,
        });

        window.$('.close-modal').html('');

        this.element.querySelector('.close-modal').addEventListener('click', e => {
            e.preventDefault();
            this.close();
        });
    }

    close() {
        this.resetForm();

        window.$('#closePayModal').click()
    }

    resetForm() {
        this.state.isOpen = false;

        this.mtElement.innerHTML = "";
        window.$(this.mtElement).hide();

        window.$(this.cardElement).parent().show();
        window.$(this.qsakElement).parent().show();
        window.$(this.smsCancelElement).parent().hide();
        window.$(this.emailInput).parent().show();
        window.$(this.smsElement).parent().show();
        // window.$(this.phoneInput).parent().show();
        window.$(this.idramElement).parent().show();

        clearInterval(this.checkIntervalID);
    }

    get email() {
        return this.emailInput.value;
    }

    get phone() {
        return this.phoneInput.value;
    }

    initEvents() {
        document.addEventListener('keypress', e => {
            if(e.key === "Escape" || e.key === '`') {
                this.close();
            }
        });

        this.smsCancelElement.addEventListener('click', () => this.resetForm());

        this.smsElement.addEventListener('click', async () => {

            try {

                let res = await (await fetch(`/api/getSMSCode/${this.announcementID}?email=${this.email}`)).json();

                let code = res.code;

                let template = this.mtElement.getAttribute('data-template');

                let text = template.replace('%code%', 'SEND' + code);
                this.mtElement.innerHTML = text;
                window.$(this.mtElement).show();


                this.checkIntervalID = setInterval(async () => {
                    let res = await (await fetch(`/api/isSMSReceived/${code}`)).json();

                    if(res.success)
                    {
                        location.href = `/announcement/${this.announcementID}?show_contacts=${res.transaction_id}`;
                    }

                }, 1500);

                window.$(this.cardElement).parent().hide();
                window.$(this.smsElement).parent().hide();
                window.$(this.smsCancelElement).parent().show();
                window.$(this.emailInput).parent().hide();
                window.$(this.qsakElement).parent().hide();
                // window.$(this.phoneInput).parent().hide();
                window.$(this.idramElement).parent().hide();
            } catch (e) {

            }


        });

        this.idramForm.addEventListener('submit', async e => {
            e.preventDefault();
            if(typeof panel !== 'undefined' && panel.editor) return;

            try {
                let res = await (await fetch(`/payment/idram/getPaymentId/${this.announcementID}?email=${this.email}&phone=${this.phone}`)).json();

                let sum = res.price;
                let id = res.id;

                this.idramForm.querySelector('input[name="EDP_AMOUNT"]').value = sum;
                this.idramForm.querySelector('input[name="EDP_BILL_NO"]').value = id;

                this.idramForm.submit();
            } catch (e) {
                console.log(e);
            }
        });


        if(this.cardElement)
            this.cardElement.addEventListener('click', e => {
                e.preventDefault();
                if(typeof panel !== 'undefined' && panel.editor) return;

                location.href = `/payment/vpos/create/${this.announcementID}?email=${this.email}&phone=${this.phone}`;
            });
    }
}

module.exports = PayModal;